<ng-container *ngIf="job && project">
    <ion-row>
        <ion-col>
            <h2 class="dp-mt-m">{{ 'projects.jobs.details.signature-section-title' | translate }}</h2>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col>
            <ion-card class="weather-card">
                <ion-card-content>
                    <div class="job-signature-display-wrap" *ngIf="job.signatures.length > 0; else jobSignaturesNoData">
                        <ion-row>
                            <ion-col size="12" size-md="6" *ngFor="let signature of job.signatures; let signatureIndex = index">
                                <div class="job-signature dp-mb-s">
                                    <app-attachment-view
                                        [attachment]="signature"
                                        (attachmentDeleted)="onSignatureRemoved(signatureIndex)"
                                        [canDelete]="changesAllowed"
                                        [showAdditionalText]="signature.displayName != null && signature.displayName.trim() !== ''"
                                        [additionalText]="signature.displayName"
                                        [limitedHeight]="'small'"
                                        [canEdit]="false"
                                    ></app-attachment-view>
                                </div>
                            </ion-col>
                        </ion-row>
                    </div>
                    <ng-template #jobSignaturesNoData>
                        <div class="ion-text-center dp-mb-s">{{ 'projects.jobs.details.no-signature-yet' | translate }}</div>
                    </ng-template>
                    <ng-container *ngIf="changesAllowed">
                        <app-signature
                            [folderPath]="project._id + '/jobs/' + job._id"
                            (signatureConfirmed)="onSignatureAdded($event)"
                        ></app-signature>
                    </ng-container>
                </ion-card-content>
            </ion-card>
        </ion-col>
    </ion-row>
</ng-container>
